function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,1484.000000) scale(0.100000,-0.100000)",
  fill: "#c18c5e",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7810 11144 l-495 -495 282 -277 282 -277 5 -1683 c2 -926 1 -1682 -4 -1680 -4 2 -388 377 -853 833 l-845 830 -1 1598 c-1 878 -4 1597 -9 1597 -4 0 -516 -508 -1137 -1130 l-1130 -1130 228 -228 227 -227 0 -617 0 -617 898 -901 897 -901 425 1 425 0 1343 1343 1342 1342 0 1558 0 1557 -693 0 -692 0 -495 -496z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4360 3735 l0 -585 2665 0 2665 0 0 585 0 585 -2665 0 -2665 0 0 -585z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "390.5 320 578.5 849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3bf7a9cc.svg";
export { ForwardRef as ReactComponent };